module.exports = __webpack_public_path__ + "static/media/focus-not-active.84c852fd.png";